// extracted by mini-css-extract-plugin
export default {"login":"error-auth_login__ZKQAw"};